
import { Component, Prop, Vue } from 'vue-property-decorator';
import IButton from '@/ui-components/IButton/IButton.vue';
import { StoreCampaign } from '@/types/campaigns';

@Component({
  name: 'Header',
  components: {
    IButton,
  },
})
export default class Header extends Vue {
  @Prop({ type: Object }) public campaign!: StoreCampaign;

  public get campaignType() {
    return this.campaign.category;
  }

  public back() {
    return this.$router.go(-1);
  }
}
